import React, { useEffect, useState } from "react";
import { Tooltip } from "react-tooltip";

const lang_texts = {
  hu: {
    FIRST_PHASE:
      "Tedd sorrendbe az alábbi szavakat 1-4 ig, aszerint melyik a legjellemzőbb rád (1.) és melyik a leginkább nem (4.).",
    SECOND_PHASE:
      "Tedd sorrendbe az alábbi szavakat 1-7 ig, aszerint melyik a legjellemzőbb rád (1.) és melyik a leginkább nem (7.).",
    LAST_PHASE:
      "Add meg az adataid és küldd el a kitöltésedet kiértékelésre. Létező e-mail címet adj meg, mert az eredményt ide fogod megkapni.",
    NEXT: "Következő oldal",
    PAGE: "oldal",
    WARNING: "Kérlek tegyél a helyére minden szót, hogy a következő oldalra léphess."
  },
  en: {
    FIRST_PHASE:
      "Arrange the following words from 1 to 4, with 1 being the most characteristic of you and 4 being the least characteristic of you.",
    SECOND_PHASE:
      "Arrange the following words from 1 to 7, with 1 being the most characteristic of you and 7 being the least characteristic of you.",
    LAST_PHASE:
      "Provide your details and send your completed form for evaluation. Please provide a valid email address, as you will receive the results there.",
    NEXT: "Next Page",
    PAGE: "page",
    WARNING: "Please put every word in its place so you can move on to the next page."
  },
};

const UrlParams = new URLSearchParams(window.location.search);
const lang = UrlParams.get("lang") || "hu";

const DragAndDropScreen = (props) => {
  const [draggedId, setDraggedId] = useState(null);
  const [sourceIndex, setIndex] = useState(null);
  const [sourceIndex2, setIndex2] = useState(null);
  const [placedWords, setPlacedWords] = useState([]);
  const [fromResult, setFromResult] = useState(false);
  let mouseOn = 0;
  const [tooltipOpenedId, setTooltipOpenedId] = useState(0);

  const [result1, setResult1] = useState(Array(4).fill(0));
  const [result2, setResult2] = useState(Array(4).fill(0));
  const [result3, setResult3] = useState(Array(4).fill(0));
  const [result4, setResult4] = useState(Array(4).fill(0));
  const [result5, setResult5] = useState(Array(4).fill(0));
  const [result6, setResult6] = useState(Array(4).fill(0));
  const [result7, setResult7] = useState(Array(4).fill(0));

  const results = [
    result1,
    result2,
    result3,
    result4,
    result5,
    result6,
    result7,
  ];
  const setResults = [
    setResult1,
    setResult2,
    setResult3,
    setResult4,
    setResult5,
    setResult6,
    setResult7,
  ];

  const handleDrop = (e, index, index2) => {
    e.preventDefault();

    setDraggedId(null);

    if (index !== sourceIndex) return;
    if (fromResult && index2 === sourceIndex2) return;

    let placedWordsTemp = placedWords;

    const wordObj = props.rawWords.find((word) => word.wordID === draggedId);
    const arr = results[index];

    const targetResult = results[index][index2];
    if (!fromResult) {
      placedWordsTemp = placedWords.filter((id) => id !== targetResult.wordID);
    }

    if (fromResult) {
      arr[sourceIndex2] = targetResult;
    }
    arr[index2] = wordObj;

    setResults[index](arr);

    placedWordsTemp.push(wordObj.wordID);
    setPlacedWords(placedWordsTemp);
    setFromResult(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };
  const onDragStart = (wordId, index, index2, fromResult) => {
    setDraggedId(wordId);
    setIndex(index);
    setIndex2(index2);
    setFromResult(fromResult);
  };

  useEffect(() => {
    setResult1(Array(props.page === 7 ? 7 : 4).fill(0));
    setResult2(Array(props.page === 7 ? 7 : 4).fill(0));
    setResult3(Array(props.page === 7 ? 7 : 4).fill(0));
    setResult4(Array(props.page === 7 ? 7 : 4).fill(0));
    setResult5(Array(props.page === 7 ? 7 : 4).fill(0));
    setResult6(Array(props.page === 7 ? 7 : 4).fill(0));
    setResult7(Array(props.page === 7 ? 7 : 4).fill(0));
    setPlacedWords([]);
  }, [props.page]);

  useEffect(() => {
    console.log({ results, draggedId });
  }, [results, draggedId]);

  return (
    <div
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <div
        style={{
          fontSize: 20,
          color: "black",
          fontWeight: 500,
          marginTop: 42,
          textAlign: "center",
        }}
      >
        <div
          style={{
            marginBottom: 12,
            fontSize: 16,
            color: "#FFC100",
            fontWeight: 500,
          }}
        >
          {props.page + 1 + ". " + lang_texts[lang].PAGE}
        </div>
        {props.page >= 0 && props.page <= 6 && lang_texts[lang].FIRST_PHASE}
        {props.page === 7 && lang_texts[lang].SECOND_PHASE}
      </div>
      <div style={{ display: "flex" }}>
        <div>
          {results.map((arr, index) => {
            return (
              <div
                style={{ margin: 24, border: "1px solid #dddddd" }}
                className="dropWrapper"
              >
                {arr.map((result, index2) => (
                  <>
                    <div
                      className={result.text ? "dragButton" : "dropPlace"}
                      draggable={!!result.text}
                      onDrop={(e) => handleDrop(e, index, index2)}
                      onDragOver={(e) => handleDragOver(e)}
                      onDragStart={() => {
                        console.log({ result, index, index2 });
                        onDragStart(result.wordID, index, index2, true);
                      }}
                      /*onMouseEnter={() => {
                        console.log(result.wordID);
                        mouseOn = result.wordID;
                        console.log({mouseOn});
                        setTimeout(() => mouseOn === result.wordID && setTooltipOpenedId(result.wordID) , 1500);
                      }}
                      onMouseLeave={() => {
                        if (mouseOn === result.wordID) {
                          mouseOn = null;
                        }
                        if (tooltipOpenedId === result.wordID) setTooltipOpenedId(null);
                      }}*/
                      data-tooltip-id={"my-tooltip"}
                      data-tooltip-delay-show={1500}
                      data-tooltip-content={result.description}
                      style={{
                        margin: 12,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {result.text}
                    </div>
                  </>
                ))}
              </div>
            );
          })}
        </div>
        <div>
          {props.words[props.page].map((array, index) => {
            return (
              <div
                style={{
                  margin: "24px 24px 38px 24px",
                  border: "0px solid #dddddd",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {array.map((word, index2) =>
                  word ? (
                    <>
                      <div
                        data-tooltip-id={"my-tooltip"}
                        data-tooltip-delay-show={1500}
                        data-tooltip-content={word.description}
                        className={"dragButton"}
                        draggable={
                          !placedWords.includes(word.wordID) && !draggedId
                        }
                        onDragStart={() =>
                          onDragStart(word.wordID, index, index2, false)
                        }
                        onDragEnd={(e) => setDraggedId(null)}
                        onClick={() => setTooltipOpenedId(null)}
                        /*onMouseEnter={() => {
                          console.log(word.wordID);
                          mouseOn = word.wordID;
                          console.log({mouseOn});
                          setTimeout(() => mouseOn === word.wordID && setTooltipOpenedId(word.wordID) , 1500);
                        }}
                        onMouseLeave={() => {
                          setTooltipOpenedId(null);
                          setTooltipOpenedId(null);
                        }}*/
                        style={{
                          margin: "12px 12px 0px 12px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          visibility: placedWords.includes(word.wordID)
                            ? "hidden"
                            : "visible",
                          opacity: placedWords.includes(word.wordID) ? 0 : 1,
                        }}
                      >
                        {word.text}
                      </div>
                    </>
                  ) : (
                    ""
                  )
                )}
              </div>
            );
          })}
        </div>
      </div>
      <button
        className={"button"}
        style={{
          margin: "24px 0",
          opacity: results.find((arr) => arr.includes(0)) ? "0.6" : 1,
          cursor: "pointer",
        }}
        onClick={(e) => {
          e.preventDefault();
          if (!results.find((arr) => arr.includes(0))) {
          window.scrollTo(0, 0);
          props.nextPage(results);
        } else {
          alert(lang_texts[lang].WARNING);
          return;
        }}}
      >
        {lang_texts[lang].NEXT}
      </button>
      <p style={{ fontSize: 16, color: "#FFC100", fontWeight: 500 }}>
        {props.page + 1 + ". " + lang_texts[lang].PAGE}
      </p>
      <Tooltip id={"my-tooltip"} delayShow={1500} />
    </div>
  );
};

export default DragAndDropScreen;
